import React, { useContext } from 'react';
import { Field } from 'redux-form';
import { BodyText, CaptionText } from '@paypalcorp/pp-react';
import TextAreaWithByteCounter from '../../../shared/fields/TextAreaWithByteCounter';
import { MessageFormat } from '@paypalcorp/worldready';
import {
  Message,
  Context as WorldReadyContext,
} from '@paypalcorp/worldready-react';

const MAX_BYTE_LIMIT = 127;

const renderPurposeTextArea = (props) => {
  return <TextAreaWithByteCounter {...props} />;
};

function Purpose() {
  const worldReady = useContext(WorldReadyContext);

  const label = new MessageFormat(worldReady, {
    id: 'buttonsV3.purpose.text.label',
  }).format();

  const ariaLabel = new MessageFormat(worldReady, {
    id: 'buttonsV3.purpose.counter.ariaLabel',
  }).format({ byteCount: '{byteCount}', maxByteCount: '{maxByteCount}' });

  return (
    <div className="purpose-container">
      <BodyText strong className="purpose-title">
        <Message id="buttonsV3.purpose.title" />
      </BodyText>
      <CaptionText className="purpose-subtitle">
        <Message id="buttonsV3.purpose.subTitle" />
      </CaptionText>
      <Field
        id="purpose"
        name="purpose"
        component={renderPurposeTextArea}
        textLabel={label}
        counterLabel={ariaLabel}
        maxByteLimit={MAX_BYTE_LIMIT}
      />
    </div>
  );
}

export default Purpose;
